import React from 'react'
import styled from '@emotion/styled'
import SettingsOutlined from '../../../assets/icons/settingsOutlined.svg'

import LogoutIcon from '../../../assets/icons/logout.svg'
import { Box, Divider } from '@mui/material'
import CustomMenuList from '../../muiComponents/languageMenu'
import { logout, userInfo } from '../../../features/user/userSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { ui } from '../../../utils/uiTokens'

const BottomLinks = ({ userRole }) => {
    const dispatch = useAppDispatch()
    const user = useAppSelector(userInfo)
    const navigate = useNavigate()
    const { formatMessage } = useIntl()

    return (
        <Wrapper>
            <Divider sx={{ borderColor: ui.border, mb: 1 }} />

            <Row
                onClick={
                    userRole === 'CURATOR'
                        ? () => navigate('/curator/profile')
                        : undefined
                }
            >
                <img
                    alt="settings"
                    src={SettingsOutlined}
                />

                <span>{formatMessage({ id: 'settings' })}</span>
            </Row>

            <Box sx={{ px: '4px' }}>
                <CustomMenuList />
            </Box>

            <Divider sx={{ borderColor: ui.border, my: 1.5 }} />

            <UserBox>
                <Name>
                    {user?.firstName} {user?.lastName}
                </Name>

                <Email>{user?.email}</Email>
            </UserBox>

            <Row onClick={() => dispatch(logout())}>
                <img
                    src={LogoutIcon}
                    alt="logout"
                />

                <span>{formatMessage({ id: 'logout' })}</span>
            </Row>
        </Wrapper>
    )
}

export default BottomLinks

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

// Тот же вид, что у пунктов меню выше: иконка слева, подпись рядом
const Row = styled.div`
    display: grid;
    grid-template-columns: 18px auto;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px;
    margin: 2px 0;
    border: none;
    border-radius: 12px;
    background: transparent;
    text-align: left;
    cursor: pointer;
    font: inherit;

    img {
        width: 18px;
        height: 18px;
        opacity: 0.45;
    }

    span {
        font-size: 14px;
        color: ${ui.sub};
    }

    &:hover {
        background: #fcfafc;

        span {
            color: ${ui.ink};
        }
    }
`

const UserBox = styled.div`
    padding: 4px 10px 8px;
`

const Name = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${ui.ink};
`

const Email = styled.div`
    font-size: 12px;
    color: ${ui.muted};
    overflow-wrap: anywhere;
`
